import { isObject } from 'lodash';

export type WhiteLabelConfig = {
    product: boolean;
    story: boolean;
};

export const DEFAULT_WHITE_LABEL_CONFIG: WhiteLabelConfig = {
    product: false,
    story: true,
};

export const sanitizeWhiteLabelConfig = (
    whiteLabel: unknown
): WhiteLabelConfig => {
    if (!isObject(whiteLabel)) return DEFAULT_WHITE_LABEL_CONFIG;
    return {
        product:
            'product' in whiteLabel && typeof whiteLabel.product === 'boolean'
                ? whiteLabel.product
                : DEFAULT_WHITE_LABEL_CONFIG.product,
        story:
            'story' in whiteLabel && typeof whiteLabel.story === 'boolean'
                ? whiteLabel.story
                : DEFAULT_WHITE_LABEL_CONFIG.story,
    };
};
